import { Phone, Mail } from 'lucide-react';
import { company } from '../mock';

export default function MobileCallBar() {
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-stone-200 shadow-[0_-8px_24px_-12px_rgba(0,0,0,0.18)]">
      <div className="grid grid-cols-2">
        <a
          href={`tel:${company.phone.replace(/\s/g, '')}`}
          className="flex items-center justify-center gap-2 py-3.5 text-[#0b6b5b] font-semibold border-r border-stone-200 active:bg-stone-50"
        >
          <Phone className="h-4 w-4" /> Call
        </a>
        <a
          href={`mailto:${company.email}`}
          className="flex items-center justify-center gap-2 py-3.5 text-[#0b6b5b] font-semibold active:bg-stone-50"
        >
          <Mail className="h-4 w-4" /> Email
        </a>
      </div>
    </div>
  );
}
